class ComponentProductGallery extends Theme.Component {
  #active_index = null;
  #mobile = null;

  connectedCallback() {
    super.connectedCallback();

    this.addDirectEvent("scroll", this.elements.slider.elements.container, this.sync);
    this.addDirectEvent("resize", window, this.sync);
    (this.elements.thumbnails || []).forEach((thumbnail, index) => {
      this.addDirectEvent("click", thumbnail, () => this.select({ index }));
    });

    this.sync();
  }

  select({ index }) {
    const items = this.elements.slider.elements.items;
    const left = items[index].getBoundingClientRect().left - items[0].getBoundingClientRect().left;

    this.elements.slider.animateScrollTo(left);
  }

  sync() {
    const container = this.elements.slider.elements.container;
    const items = this.elements.slider.elements.items;
    let index = 0;
    let distance = Infinity;

    items.forEach((item, item_index) => {
      const left = item.getBoundingClientRect().left - items[0].getBoundingClientRect().left;
      const item_distance = Math.abs(left - container.scrollLeft);

      if (item_distance < distance) {
        index = item_index;
        distance = item_distance;
      }
    });

    (this.elements.thumbnails || []).forEach((thumbnail, thumbnail_index) => {
      thumbnail.setAttribute("aria-current", String(thumbnail_index === index));
    });

    const mobile = window.matchMedia("(max-width: 767px)").matches;

    if (index !== this.#active_index || mobile !== this.#mobile) {
      items.forEach((item, item_index) => {
        const video = item.querySelector("component-video");
        video?.toggleAttribute("active", mobile && item_index === index);

        if (video && (!mobile || item_index !== index)) {
          video.pause();
        }
      });

      this.#mobile = mobile;
      this.#active_index = index;
      this.showThumbnail(index);
    }
  }

  showThumbnail(index) {
    const slider = this.elements["thumbnail-slider"];
    const container = slider.elements.container;
    const thumbnail = this.elements.thumbnails?.[index];

    if (!thumbnail || !container.clientWidth) {
      return;
    }

    const box = container.getBoundingClientRect();
    const thumbnail_box = thumbnail.getBoundingClientRect();
    const style = getComputedStyle(container);
    const left = box.left + parseFloat(style.paddingLeft);
    const right = box.right - parseFloat(style.paddingRight);

    if (thumbnail_box.left < left - 1 || thumbnail_box.right > right + 1) {
      slider.animateScrollTo(container.scrollLeft + thumbnail_box.left - left);
    }
  }
}

customElements.define("component-product-gallery", ComponentProductGallery);
